import { isSome, Maybe } from '@crocodille/util';
import { Switch as HeadlessSwitch } from '@headlessui/react';
import IconCheck from '@icons/check';
import cn from 'classnames';

import styles from './checkbox.module.scss';

import type { FormField } from '@crocodille/common';

type FieldProps = 'value' | 'onChange' | 'disabled' | 'onBlur';

export function fieldToCheckboxProps(
  field: Pick<FormField<Maybe<boolean>>, 'error' | FieldProps>,
) {
  return {
    invalid: isSome(field.error),
    value: field.value === null ? false : field.value,
    onChange: field.onChange,
    onBlur: field.onBlur,
    disabled: field.disabled,
  } satisfies Pick<CheckboxProps, 'invalid' | FieldProps>;
}

export interface CheckboxProps {
  readonly value?: boolean;
  readonly onChange?: (value: boolean) => void;
  readonly label: React.ReactNode;
  readonly name?: string;
  readonly invalid?: boolean;
  readonly disabled?: boolean;
  readonly required?: boolean;
  readonly onBlur?: () => void;
  readonly htmlValue?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  value,
  onChange,
  label,
  name,
  invalid,
  disabled,
  onBlur,
  htmlValue,
}) => {
  return (
    <HeadlessSwitch.Group as="div" className={styles.container}>
      <HeadlessSwitch
        name={name}
        checked={value}
        value={htmlValue}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        className={({ checked }) =>
          cn(styles.checkbox, {
            [styles.isChecked]: checked,
            [styles.isInvalid]: invalid,
          })
        }
      >
        <span className={styles.box} />
        <IconCheck className={styles.check} />
      </HeadlessSwitch>
      <HeadlessSwitch.Label className={styles.label}>
        {label}
      </HeadlessSwitch.Label>
    </HeadlessSwitch.Group>
  );
};

export default Checkbox;
